import React from 'react';

export default {
  title: 'On this occasion, we haven’t been able to identify the shareholders',
  contact:
    'Our team will be in touch with you either by phone or email, to ask for the address and date of birth for shareholders who run the business, typically within the next 24 hours.',
  bullets: {
    start: 'Please note',
    bullet1: () => (
      <>
        We only need details of shareholders <b>with voting rights</b> that
        cover 50% of the business.
      </>
    ),
    bullet2: 'One of the shareholders must cover at least 20%.',
    bullet3:
      'The shareholders you select must have UK residency or indefinite leave to remain.',
    bullet4:
      'The names provided must appear exactly as they do on their ID documents.'
  }
};
